import type { SVGProps } from "react";
export interface WaterBottleIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function WaterBottleIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: WaterBottleIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M15.126 5a1.125 1.125 0 0 1-2.25 0V3.125h-1.751V5a1.125 1.125 0 0 1-2.25 0V3c0-1.173.952-2.125 2.126-2.125H13c1.174 0 2.126.952 2.126 2.125z"
      />
      <path
        fill={color}
        d="M15.876 8.83a.88.88 0 0 0-.149-.487l-.108-.134-2.084-2.084h-3.07L8.382 8.209a.88.88 0 0 0-.256.62v1.625q.027.03.075.082c.073.075.254.251.397.46.162.237.32.575.32 1.005s-.158.765-.32 1.003c-.143.208-.324.385-.397.46q-.049.05-.075.08v.41q.027.033.075.083c.073.075.256.251.398.46.163.237.32.575.32 1.005 0 .428-.159.765-.321 1.003-.143.208-.324.385-.397.46q-.049.05-.075.08V19c0 1.036.84 1.876 1.875 1.876h4c1.036 0 1.876-.84 1.876-1.875v-1.955l-.075-.08c-.074-.075-.256-.253-.399-.462a1.8 1.8 0 0 1-.313-.846l-.008-.157.008-.157a1.8 1.8 0 0 1 .313-.846c.143-.209.325-.387.399-.462q.048-.05.075-.082v-.406l-.077-.082c-.074-.076-.256-.252-.398-.461a1.8 1.8 0 0 1-.312-.848L15.08 12l.008-.157a1.8 1.8 0 0 1 .312-.847c.143-.21.324-.387.398-.463q.05-.051.077-.083V8.829Zm2.25 1.755c0 .704-.394 1.18-.617 1.414.222.234.616.71.616 1.415v.672c0 .702-.389 1.177-.613 1.414.224.237.613.712.613 1.414v2.085a4.125 4.125 0 0 1-4.124 4.126H10A4.125 4.125 0 0 1 5.875 19v-2.086c0-.703.39-1.177.614-1.414-.224-.237-.614-.711-.614-1.414v-.672c0-.703.39-1.178.614-1.415-.225-.237-.614-.712-.614-1.414V8.83c0-.829.33-1.624.916-2.21l2.414-2.414.171-.141c.183-.122.4-.189.624-.189h4l.22.022c.217.043.418.15.576.308L17.21 6.62l.208.23c.455.556.707 1.255.707 1.98v1.756Z"
      />
    </svg>
  );
}
